module.exports = __webpack_public_path__ + "static/media/logo.3df61423.png";